import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Navigation } from '../_components';

const PrivateAdminRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        rest.isAuthenticated && rest.sessionData.user.is_admin
            ? <div><Navigation></Navigation><br/><Component {...props} /></div>
            : <div><Redirect exact to={{ pathname: '/tasks', state: { from: props.location } }} /></div>
    )} />
)

const mapStateToProps = state => ({
  sessionData: state.session,
  isAuthenticated: state.session && state.session.user && state.session.user.authentication_token?true:false
})

const connectedPrivateAdminRoute = connect(mapStateToProps)(PrivateAdminRoute);
export { connectedPrivateAdminRoute as PrivateAdminRoute };
